import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { SvgIconModule } from '../svg-icon/svg-icon.module';
import { NumberSpinnerModule } from '../number-spinner/number-spinner.module';
import { AccessibilityFontSizeSetterComponent } from './accessibility-font-size-setter.component';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    SvgIconModule,
    NumberSpinnerModule
  ],
  declarations: [
    AccessibilityFontSizeSetterComponent
  ],
  exports: [
    AccessibilityFontSizeSetterComponent
  ]
})

export class AccessibilityFontSizeSetterModule {}
